export interface Job {
  id: string;
  title: string;
  location: {
    state: string;
    country: string;
  };
  type: string;
  jobId: string;
  jobSchedule: string;
  payRange: string;
  jobFamily: string;
  shift: string;
  jdAbout: string;
  jdValues: string[];
  jdMinQual: string[];
  jdPrefQual: string[];
  jdBenefits: string[];
}

const jobs: Job[] = [
    /*{
      id: '1',
      title: 'Registered Nurse RN Home Health',
      location: { state: 'New Jersey', country: 'US' },
      type: 'Full Time',
      jobId: '123456789',
      jobSchedule: 'Full Time',
      payRange: '$31.53 - $52.23 per hour',
      jobFamily: 'Home Care',
      shift: '1 - Day',
      jdAbout: `The Home Health Registered Nurse (RN) Care Manager is a professional nurse who coordinates and directs the home care patient's care based on individual patient needs. The RN Care Manager is responsible for independent management of the Home Health patient population requiring the use of advanced assessment, teaching and decision-making skills. The nurse is responsible for ensuring that appropriate referrals to other services are made, interdisciplinary conferencing takes place regularly, and appropriate documentation is completed. Relevant knowledge and experience is consistently applied to new patient populations. The Care Manager cares for a caseload of home health patients by evaluating the patient for appropriateness of home health and developing the home care plan in conjunction with the physician. S/he educates patients, families, caregivers and community providers to safely perform care. S/he provides follow up by evaluating effectiveness of the home care plan, and monitoring patient/family's response to the plan to achieve patient/family goals and top decile outcomes. The Care Manager also identifies performance improvement and home health standard of care initiatives and assists to design or implement programs to address needed changes.`,
      jdValues: [
        'Coordinates and directs the care of a caseload of home patients when the primary skill needed is nursing. Provides comprehensive assessment, planning, implementation and evaluation for that caseload as the primary nurse.',
        'Sets priorities of home care caseload adapting to the changing needs of the home care patients and families. Optimizes schedule daily to support productivity, efficiency and maintain best practice visit utilization.',
        'Assesses physical, functional, psychosocial, social, spiritual, educational, developmental, cultural, cognitive status and discharge planning needs of the home care patient utilizing interview observations and physical exam techniques. Assesses the home environment for safety, infection control, and community resource needs. Reviews patient history and physical, diagnostics and laboratory data. Reviews available information obtained by other team members. Reports abnormal items and results to the physician as appropriate and reviews with patient family. Accurately and timely documents these assessments.',
        'Implements the plan of care through direct patient care, coordination, delegation and supervision of the activities of the health care team. Provides care based on physician\'s orders, in compliance with policies and procedures, standards of care, and regulatory requirements. Delegates appropriately and provides nursing supervision in the provision of care to patients by other licensed nurses and other personnel. Promotes continuity of care by accurately and completely communicating to other caregivers the status of patient for whom care is provided. Provides skilled nursing care, preventative rehabilitative procedures, and prescribed treatments with a variety of patient populations within various potentially complex home situations.',
        'Informs the physician, clinical manager, and other appropriate members of the health care team of changes in the patient\'s condition and needs. Facilitates and coordinates interdisciplinary care conferences with groups of complex patients.'
      ],
      jdMinQual: [
        'Current Registered Nursing License in State of Practice',
        'Valid Driver\'s License and current car insurance',
        'Active American Heart Association BLS',
        'Minimum of one-year relevant clinical RN experience'
      ],
      jdPrefQual: [
        'Recent, relevant experience in a Medicare-certified home health agency as a case-manager',
        'Bachelors degree in nursing',
        'Home Health Case-Manager Certification',
        'COS-C'
      ],
      jdBenefits: [
        'Up to $10,000 Sign on Bonus',
        'Benefits from Day One',
        'Paid Time Off from Day One',
        'Career Development',
        'Whole Person Wellbeing Resources',
        'Mental Health Resources and Support'
      ]
    },
    {
      id: '2',
      title: 'Registered Nurse RN Home Health',
      location: { state: 'New Jersey', country: 'US' },
      type: 'Part Time',
      jobId: '987654321',
      jobSchedule: 'Part Time',
      payRange: '$28.00 - $45.00 per hour',
      jobFamily: 'Home Care',
      shift: '2 - Night',
      jdAbout: 'Job description coming soon.',
      jdValues: ['Value 1', 'Value 2'],
      jdMinQual: [],
      jdPrefQual: [],
      jdBenefits: []
    },
    {
      id: '3',
      title: 'Registered Nurse RN Home Health',
      location: { state: 'New Jersey', country: 'US' },
      type: 'Full Time',
      jobId: '112233445',
      jobSchedule: 'Full Time',
      payRange: '$30.00 - $50.00 per hour',
      jobFamily: 'Home Care',
      shift: '3 - Evening',
      jdAbout: 'Job description coming soon.',
      jdValues: ['Value 1', 'Value 2'],
      jdMinQual: [],
      jdPrefQual: [],
      jdBenefits: []
    }*/
  ];

export default jobs;
